import { SimpleEventDispatcher } from 'strongly-typed-events';

export default class QuestionService {
    static readonly onAnswer = new SimpleEventDispatcher<boolean>();
}
